import React from 'react';
import PropTypes from 'prop-types';
import SkyLight from 'react-skylight';
import { ObjectInspector } from 'react-inspector';
import './ErrorMessage.scss';

/*
Shows ☠ (&#9760;) rather than ⚠ (&#9888;).
 */

const ErrorMessage = (props) => {
  const { error = null } = props;
  if (error) {
    console.dir(error);
  }
  if (error === null) {
    return (
      <div className="ErrorMessage">
        <div className="skull">&#9760;</div>
        <div className="message"><span className="intro">ERROR</span></div>
      </div>);
  }
  if (typeof error === 'string') {
    console.log('\t' + error);
    return (
      <div className="ErrorMessage">
        <div className="skull">&#9760;</div>
        <div className="message">ERROR:</div>
        <div className="message">
          {props.error}
        </div>
      </div>);
  }
  console.log('\t' + ((error && error.message) ? error.message : error));
  let dialog = null;
  return (
    <div className="ErrorMessage">
      <div
        role="button"
        tabIndex={0}
        className="skullButton"
        onKeyDown={() => { dialog.show(); }}
        onClick={() => { dialog.show(); }}
      >
        <div className="huge">&#9760;</div>
        <div>ERROR</div>
      </div>
      <div className="message">{error.message}</div>
      <div className="align-left">
        <SkyLight
          hideOnOverlayClicked
          ref={(ref) => { dialog = ref; }}
          title="Details"
          transitionDuration={400}
          dialogStyles={{
            backgroundColor: '#242424',
            border: '1px solid white',
            color: 'white',
            overflow: 'scroll',
          }}
        >
          <ObjectInspector
            data={error}
            theme="chromeDark"
            expandLevel={2}
          />
        </SkyLight>
      </div>
    </div>
  );
};

ErrorMessage.propTypes = { error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]) };

ErrorMessage.defaultProps = { error: 'ERROR' };

export default ErrorMessage;
